import React from "react";
import { useNavigate } from "react-router-dom";
import "./styles.less";
import { useTranslation } from "react-i18next";

export const SolutionHot = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const list = [
    {
      title: `${t("solution.list.hot-solution.education.title")}`,
      type: "education",
      imgurl: "//files.authing.co/authing-website/solution-icon-education.svg",
      text: `${t("solution.list.hot-solution.education.subtitle")}`,
    },
    {
      title: `${t("solution.list.hot-solution.game.title")}`,
      type: "game",
      imgurl: "//files.authing.co/authing-website/solution-icon-game.svg",
      text: `${t("solution.list.hot-solution.game.subtitle")}`,
    },
    {
      title: `${t("solution.list.hot-solution.it.title")}`,
      type: "software",
      imgurl: "//files.authing.co/authing-website/solution-icon-soft.svg",
      text: `${t("solution.list.hot-solution.it.subtitle")}`,
    },
    {
      title: `${t("solution.list.hot-solution.govenment.title")}`,
      type: "government",
      imgurl: "//files.authing.co/authing-website/solution-icon-govenment.svg",
      text: `${t("solution.list.hot-solution.govenment.subtitle")}`,
    },
    {
      title: `${t("solution.list.hot-solution.finance.title")}`,
      type: "finance",
      imgurl: "//files.authing.co/authing-website/solution-icon-fiance.svg",
      text: `${t("solution.list.hot-solution.finance.subtitle")}`,
    },
    {
      title: `${t("solution.list.hot-solution.publisher.title")}`,
      type: "publisher",
      imgurl: "//files.authing.co/authing-website/solution-icon-coryright.svg",
      text: `${t("solution.list.hot-solution.publisher.subtitle")}`,
    },
    {
      title: `${t("solution.list.hot-solution.medical.title")}`,
      type: "medical",
      imgurl: "//files.authing.co/authing-website/solution-icon-medical.svg",
      text: `${t("solution.list.hot-solution.medical.subtitle")}`,
    },
  ];
  return (
    <section>
      <div className="solution-hot">
        <div className="inner">
          <div className="top">
            <div className="title">{t("solution.list.hot-solution.title")}</div>
            <div className="subtitle">
              {t("solution.list.hot-solution.subtitle")}
            </div>
          </div>
          <div className="card-warp">
            {list.map((item) => {
              return (
                <div className="card">
                  <div className="title">
                    <span className="icon-label">
                      <img src={item.imgurl} alt="authing icon" width={20} />
                    </span>
                    <span>{item.title}</span>
                  </div>
                  <div className="text">{item.text}</div>
                  <div
                    className="detail"
                    onClick={() => {
                      navigate(`/solutions/${item.type}`);
                    }}
                  >
                    {t("solution.list.hot-solution.common-detial")}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
